import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
    initMasterCategoryInfo,
    requestMasterCategoryStart,
    requestMasterCategorySuccess,
    requestAllMasterCategorySuccess,
    requestMasterCategoryFail,

    postMasterCategoryStart,
    postMasterCategorySuccess,
    postMasterCategoryFail,

    patchMasterCategoryStart,
    patchMasterCategorySuccess,

    deleteMasterCategoryStart,
    deleteMasterCategorySuccess,
    deleteMasterCategoryFail,

    requestDetailMasterCategoryStart,
    requestDetailMasterCategorySuccess,
    requestDetailMasterCategoryFail,

    putMasterCategoryStart,
    putMasterCategorySuccess,
    putMasterCategoryFail,

    deleteMultipleMasterCategoryStart,
    deleteMultipleMasterCategorySuccess,
    deleteMultipleMasterCategoryFail,

    patchMultipleMasterCategoryStart,
    patchMultipleMasterCategorySuccess,
    patchMultipleMasterCategoryFail,

    putMultipleMasterCategoryStart,
    putMultipleMasterCategorySuccess,
    putMultipleMasterCategoryFail,

    requestMasterCategoryProductStart,
    requestMasterCategoryProductSuccess,
    requestMasterCategoryProductFail,

    postMasterCategoryProductStart,
    postMasterCategoryProductSuccess,
    postMasterCategoryProductFail,

    postMultipleMasterCategoryProductStart,
    postMultipleMasterCategoryProductSuccess,
    postMultipleMasterCategoryProductFail,

    deleteMasterCategoryProductStart,
    deleteMasterCategoryProductSuccess,
    deleteMasterCategoryProductFail,

    importMasterCategoryStart,
    importMasterCategorySuccess,
    importMasterCategoryFail,


    requestImportMasterCategoryStart,
    requestImportMasterCategorySuccess,
    requestImportMasterCategoryFail,

} from '../actions/master-category';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PUT, method_PATCH, method_DELETE, method_MULTIPLE_DELETE, method_MULTIPLE_PATCH, method_MULTIPLE_PUT, method_MULTIPLE_POST, method_IMPORT } = requestManagement;

import CONFIG from '@root/config/config.next';

const url = CONFIG.backendEndpoint;

export function* requestMasterCategory({ payload }) {

    /*console.log('[sages] requestMasterCategory : ', payload);*/

    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
                "filter[status]": payload.status,
                "filter[q]": payload.q,
                "filter[parent]": payload.parent,
            }
        });

        /*console.log("[API] GET : ", data);*/
        if (payload.limit === 'all') {
            yield put(requestAllMasterCategorySuccess(data));
        } else {
            yield put(requestMasterCategorySuccess(data));
        }

    } catch (error) {
        yield put(requestMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* postMasterCategory({ payload }) {
    /*console.log('[sages] postMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(postMasterCategorySuccess(data));

    } catch (error) {
        yield put(postMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* patchMasterCategory({ payload }) {
    /*console.log('[sages] patchMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PATCH(
            {
                url: apiURL,
                data: payload?.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchMasterCategorySuccess(data));

    } catch (error) {
        // yield put(patchMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* deleteMasterCategory({ payload }) {
    /*console.log('[sages] deleteMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_DELETE(
            {
                url: apiURL,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMasterCategorySuccess(data));

    } catch (error) {
        yield put(deleteMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* requestDetailMasterCategory({ payload }) {

    /*console.log('[sages] requestDetailMasterCategory : ', payload);*/

    const apiURL = `${url}/backend/v1/category-display/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestDetailMasterCategorySuccess(data));

    } catch (error) {
        yield put(requestDetailMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* putMasterCategory({ payload }) {
    /*console.log('[sages] putMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PUT(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putMasterCategorySuccess(data));

    } catch (error) {
        yield put(putMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* deleteMultipleMasterCategory({ payload }) {
    /*console.log('[sages] deleteMultipleMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_DELETE(
            {
                url: apiURL,
                array: payload?.array
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMultipleMasterCategorySuccess(data));

    } catch (error) {
        yield put(deleteMultipleMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* patchMultipleMasterCategory({ payload }) {
    /*console.log('[sages] patchMultipleMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PATCH(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchMultipleMasterCategorySuccess(data));

    } catch (error) {
        yield put(patchMultipleMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* putMultipleMasterCategory({ payload }) {
    /*console.log('[sages] putMultipleMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PUT(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putMultipleMasterCategorySuccess(data));

    } catch (error) {
        yield put(putMultipleMasterCategoryFail(error));
    }

    //====================================================================================================================
}

export function* requestMasterCategoryProduct({ payload }) {

    /*console.log('[sages] requestMasterCategoryProduct : ', payload);*/

    const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/map`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
                "filter[status]": payload.status,
                "filter[q]": payload.q,
            }
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestMasterCategoryProductSuccess(data));

    } catch (error) {
        yield put(requestMasterCategoryProductFail(error));
    }

    //====================================================================================================================
}

export function* postMasterCategoryProduct({ payload }) {
    /*console.log('[sages] postMasterCategoryProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/map`;

    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(postMasterCategoryProductSuccess(data));

    } catch (error) {
        yield put(postMasterCategoryProductFail(error));
    }

    //====================================================================================================================
}

export function* postMultipleMasterCategoryProduct({ payload }) {
    /*console.log('[sages] postMultipleMasterCategoryProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_POST(
            {
                url: apiURL,
                data: payload?.data,
                array: payload?.array,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(postMultipleMasterCategoryProductSuccess(data));

    } catch (error) {
        yield put(postMultipleMasterCategoryProductFail(error));
    }

    //====================================================================================================================
}

export function* deleteMasterCategoryProduct({ payload }) {
    /*console.log('[sages] deleteMasterCategoryProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/map`;

    //====================================================================================================================

    try {
        const data = yield method_DELETE(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMasterCategoryProductSuccess(data));

    } catch (error) {
        yield put(deleteMasterCategoryProductFail(error));
    }

    //====================================================================================================================
}


export function* importMasterCategory({ payload }) {
    /*console.log('[sages] importMasterCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/import/category-display`;
    const formData = new FormData();
    formData.append('file', payload.file);
    //====================================================================================================================

    try {
        const data = yield method_IMPORT(
            {
                url: apiURL,
                data: formData
            }
        );

        /*console.log("[API] POST : ", data);*/

        yield put(importMasterCategorySuccess(data));

    } catch (error) {
        yield put(importMasterCategoryFail(error));
    }

    //====================================================================================================================

}

export function* requestImportMasterCategory({ payload }) {

    /*console.log('[sages] requestImportMasterCategory : ', payload);*/

    const apiURL = `${url}/backend/v1/import/category-display`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
            }
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestImportMasterCategorySuccess(data));

    } catch (error) {
        yield put(requestImportMasterCategoryFail(error));
    }

    //====================================================================================================================
}


export function* watchMasterCategory() {

    /*console.log('[sages] watchMasterCategory : ✅');*/

    yield all([
        takeLatest(requestMasterCategoryStart, requestMasterCategory),
        takeLatest(postMasterCategoryStart, postMasterCategory),
        takeLatest(patchMasterCategoryStart, patchMasterCategory),
        takeLatest(deleteMasterCategoryStart, deleteMasterCategory),
        takeLatest(requestDetailMasterCategoryStart, requestDetailMasterCategory),
        takeLatest(putMasterCategoryStart, putMasterCategory),
        takeLatest(deleteMultipleMasterCategoryStart, deleteMultipleMasterCategory),
        takeLatest(patchMultipleMasterCategoryStart, patchMultipleMasterCategory),
        takeLatest(putMultipleMasterCategoryStart, putMultipleMasterCategory),
        takeLatest(requestMasterCategoryProductStart, requestMasterCategoryProduct),
        takeLatest(postMasterCategoryProductStart, postMasterCategoryProduct),
        takeLatest(postMultipleMasterCategoryProductStart, postMultipleMasterCategoryProduct),
        takeLatest(deleteMasterCategoryProductStart, deleteMasterCategoryProduct),
        takeLatest(importMasterCategoryStart, importMasterCategory),
        takeLatest(requestImportMasterCategoryStart, requestImportMasterCategory),


    ])
}



